<template>
    <div class="m-list">
        <div class="width-a">
            <h1 class="title">公开资源</h1>
            <ul class="type">
                <template v-for="(item, index) in types">
                    <li
                        :class="typeIndex == index ? 'type-b' : 'type-a'"
                        :key="item.typeId"
                        @click="typeTap(index)"
                    >
                        {{ item.label }}
                    </li>
                </template>
            </ul>
            <div class="content">
                <div class="toolsb">
                    <el-input
                        class="mb-input"
                        placeholder="请输入资源名称"
                        v-model="resourceName"
                    ></el-input>
                    <el-button type="primary" @click="toQuery">搜索</el-button>
                    <el-button type="primary" @click="resetQuery"
                        >重置</el-button
                    >
                </div>
                <ul class="ors">
                    <template v-for="(item, index) in tableData">
                        <li
                            class="c-item"
                            :key="item.resourceId"
                            @click="detailTap(index)"
                        >
                            <div class="ci-img">
                                <img :src="item.imgUrl | fileFilter" alt="" />
                            </div>
                            <h2 class="ci-title m-text-ellipsis">
                                {{ item.resourceName }}
                            </h2>
                            <p class="ci-desc m-text-ellipsis-c">
                                {{ item.introduce }}
                            </p>
                            <div class="ci-info">
                                <span>{{ item.clickCount }} 人观看</span>
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
            <el-pagination
                class="ma-pagination"
                :current-page="curPage"
                layout="total, prev, pager, next"
                :total="total"
                @current-change="handleCurrentChange"
                :page-size="6"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import Auth from "@/utils/Auth";
import HttpConnectionC from "@/utils/HttpConnectionC";
import CommonFilters from "@/mixins/CommonFilters";
export default {
    name: "OpenResource",
    mixins: [CommonFilters],
    data() {
        return {
            resourceName: "",
            tableData: [],
            types: [],
            typeIndex: -1,
            curPage: 1,
            total: 0,
        };
    },
    mounted() {
        let that = this;
        HttpConnectionC.get("homepage/listResourceCategory").then(function (
            response
        ) {
            that.types = response.data;
            that.queryData();
        });
    },
    methods: {
        queryData() {
            let that = this;
            let _categoryId = "";
            if (that.typeIndex != -1) {
                _categoryId = that.types[that.typeIndex].id;
            }
            HttpConnectionC.get("/homepage/listResources", {
                params: {
                    resourceName: that.resourceName,
                    state: 2,
                    categoryId: _categoryId,
                    pageNum: this.curPage,
                    pageSize: 6,
                },
            }).then(function (response) {
                that.tableData = response.rows;
                that.total = response.total;
            });
        },
        typeTap(index) {
            this.typeIndex = index;
            this.queryData();
        },
        handleCurrentChange(val) {
            this.curPage = val;
            this.queryData();
        },
        detailTap(index) {
            let _id = this.tableData[index].resourceId;
            this.$router.push({
                path: "/OpenResourceDetail?resourceData=" + _id,
            });
            // if (Auth.getToken()) {
            //     let _id = this.tableData[index].resourceId;
            //     this.$router.push({
            //         path: "/OpenResourceDetail?resourceData=" + _id,
            //     });
            // } else {
            //     this.$store.commit("setShowLogin", true);
            // }
        },
        toQuery() {
            this.curPage = 1;
            this.queryData();
        },
        resetQuery() {
            this.resourceName = "";
            this.curPage = 1;
            this.queryData();
        },
    },
};
</script>

<style scoped lang="scss">
.m-list {
    background-image: url("../assets/bga01.png");
    background-repeat: no-repeat;
}

.title {
    font-size: 36px;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
    padding: 60px 0px 40px 0px;
}

.type {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .type-a {
        width: 140px;
        height: 46px;
        text-align: center;
        line-height: 46px;
        background-color: #395bcd;
        color: #ffffff;
        font-size: 16px;
        margin: 0px 16px;
        cursor: pointer;
    }

    .type-b {
        width: 140px;
        height: 46px;
        text-align: center;
        line-height: 46px;
        background-color: #253b85;
        color: #ffffff;
        font-size: 16px;
        margin: 0px 16px;
        cursor: pointer;
    }
}

.content {
    padding: 60px 44px 0px 44px;
    margin-top: 60px;
    background-color: #ffffff;
}

.ors {
    display: grid;
    grid-row-gap: 20px;
    grid-column-gap: 35px;
    grid-template-columns: repeat(3, 334px);
}

.c-item {
    width: 326px;
    height: 336px;
    border: solid 1px #e3e4e5;
    padding: 20px;
    margin: 10px;
    cursor: pointer;
}

.ci-img {
    width: 286px;
    height: 176px;

    img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        margin: auto;
    }
}

.ci-title {
    font-size: 18px;
    color: #333333;
    font-weight: normal;
    padding: 0px 6px;
    margin: 15px 0px;
}

.ci-desc {
    font-size: 14px;
    color: #999999;
    padding: 0px 6px;
    height: 20px;
    margin: 10px 0;
}

.ci-info {
    color: #999999;
    font-size: 14px;
    border-top: 1px solid #e8e9eb;
    padding: 10px 6px 0px 6px;
}
</style>
